// extracted by mini-css-extract-plugin
export default {"topBlank":"topBlank__MdIEa6x1Kz"};